var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { attrs: { show: _vm.loading } },
    [
      _c("FilesFilters", {
        attrs: {
          value: _vm.filters,
          view: _vm.view,
          onChange: _vm.onChangeFilters,
          clear: _vm.clearFilters,
          fechaName: "fechaInicioCreacion",
          fechaUntilName: "fechaFinCreacion",
          defaultDate: _vm.rangeSelected
        }
      }),
      _c("FilesHeader"),
      _vm._l(_vm.files, function(file) {
        return _c("FileRow", {
          key: file.id,
          attrs: {
            file: file,
            "refresh-list": _vm.refreshList,
            "select-file": _vm.selectFile
          }
        })
      }),
      _vm.showModal
        ? _c("PopUpGeneralDetailFile", { attrs: { file: _vm.selectedFile } })
        : _vm._e(),
      _vm.selectedFile
        ? _c("PopUpSendToDocDigital", { attrs: { file: _vm.selectedFile } })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }